import * as React from "react";
import { forwardRef } from "react";
const SvgToolCircle = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} transform="translate(1 1)"><path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#CCCCCC" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
const ForwardRef = forwardRef(SvgToolCircle);
export { ForwardRef as ReactComponent };